import React from 'react';
import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useSelector } from 'react-redux';
import BottomOptions from '../../../components/RouteManagement/BottomOptions';
import useRouteManagementActionsConfig from '../../../features/routeDetail/hooks/useRouteManagementActionsConfig';
import { getSelectedPreparedStops } from '../../../store/selectors/ui/routeDetail';
import palette from '../../../components/styles/palette';
import CenterMapButton from './CenterMapButton';
import { View } from '../../../components/Base';

const useStyles = makeStyles({
  container: {
    right: 0,
    bottom: 0,
    position: 'absolute',
  },
  buttonsContainer: {
    display: 'flex',
    position: 'relative',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: 'calc(100vw - 19.625rem)',
    background: palette.typography.black.medium,
  },
  actions: {
    margin: '0px 20px 10px 30px',
  },
});

export const RouteManagementButtons = ({
  bottomOptionsVisible,
  onSelectCentreMap,
}) => {
  const style = useStyles();
  const routeManagementActionButtonsConfig = useRouteManagementActionsConfig();
  const selectedStops = useSelector(getSelectedPreparedStops);

  return (
    <View className={style.container}>
      <Box className={style.buttonsContainer}>
        {bottomOptionsVisible && (
          <BottomOptions
            isParcelDetails={false}
            selectedStops={selectedStops}
            buttonsActionConfig={routeManagementActionButtonsConfig}
            customStyle={{ container: style.actions }}
          />
        )}
        <CenterMapButton onSelectCentreMap={onSelectCentreMap} />
      </Box>
    </View>
  );
};
